export const adrCompletionLabelsFactory = [adrCompletionLabels];

function adrCompletionLabels() {
    var directive = {
        restrict: 'E',
        template: `
            <div style="display: inline-block; margin-right: 10px;">
                <span ng-show="row && row.pnCompletedPersonPK" style="background-color: #ddd; padding: 2px 6px; border-radius: 3px; margin-right: 5px;">
                    Done by <i class="material-icons" style="font-size: 14px;">directions_run</i>{{row.pnCompletedPersonPK}}
                    <span ng-if="displayDuration" style="font-weight: bold;">({{displayDuration}})</span>
                </span>
                <span ng-show="row && !row.pnCompletedPersonPK && displayDuration" style="background-color: #ddd; padding: 2px 6px; border-radius: 3px; margin-right: 5px;">
                    Duration: <span style="font-weight: bold;">{{displayDuration}}</span>
                </span>
                <span ng-if="row && row.pnTopicDetail" ng-click="row.viewExtra = (row.viewExtra ? false : true)" style="background-color: #5cb85c; color: white; padding: 2px 6px; border-radius: 3px; margin-right: 5px; cursor: pointer;">
                    {{row.pnTopicDetail}}
                </span>
                <span ng-if="row && row.pnInvoiceNote" style="background-color: #337ab7; color: white; padding: 2px 6px; border-radius: 3px;">
                    {{row.pnInvoiceNote}}
                </span>
                <span ng-if="!row" style="color: #999; font-style: italic;">Loading...</span>
            </div>
        `,
        scope: {
            row: '='
        },
        controller: ['$scope', CompletionLabelsController]
    };

    return directive;

    function CompletionLabelsController($scope) {
        $scope.displayDuration = null;

        // Initial duration calculation if row is already available
        if ($scope.row) {
            updateDuration($scope.row);
        }

        // Watch for changes to the row object
        $scope.$watch('row', function(newRow, oldRow) {
            if (newRow) {
                // Update duration when row data is available
                updateDuration(newRow);
            } else {
                // Clear duration if row becomes null/undefined
                $scope.displayDuration = null;
            }
        }, true); // deep watch

        function updateDuration(row) {
            if (!row) return;

            // Only calculate duration for completed tasks with both start and end dates
            if (row.pnCompletedUTC && row.pnCustomTimeUTC) {
                var start = new Date(row.pnCustomTimeUTC);
                var end = new Date(row.pnCompletedUTC);
                var diffMs = end - start;

                // Round to nearest minute to avoid flooring issues
                diffMs = Math.round(diffMs / (1000 * 60)) * (1000 * 60);

                if (diffMs > 0) {
                    var diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
                    var diffHours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    var diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
                    var diffSeconds = Math.floor((diffMs % (1000 * 60)) / 1000);

                    if (diffDays > 0) {
                        $scope.displayDuration = diffDays + 'd ' + diffHours + 'h ' + diffMinutes + 'm';
                    } else if (diffHours > 0) {
                        $scope.displayDuration = diffHours + ':' + (diffMinutes < 10 ? '0' : '') + diffMinutes + ':' + (diffSeconds < 10 ? '0' : '') + diffSeconds;
                    } else {
                        $scope.displayDuration = diffMinutes + ':' + (diffSeconds < 10 ? '0' : '') + diffSeconds;
                    }
                } else {
                    $scope.displayDuration = null;
                }
            } else {
                // No duration for incomplete tasks - never use row.Duration or current time
                $scope.displayDuration = null;
            }
        }
    }
}